<template>
  <v-main>

    <v-container
        id="invoice-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-bank"
          class="px-5 py-5"
      >

        <div class="page-messages">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>
        </div>

        <v-card-text v-if="invoice">

          <v-row justify="space-between">
            <v-col
                cols="12"
                lg="4"
                sm="12"
            >
              <v-card outlined class="ma-0">
                <v-card-text>
                  {{ invoice.user.names }}<br>

                  <span v-if="invoice.user.address">
                      {{ invoice.user.address }}
                      <span v-if="invoice.user.addressLine2">{{ invoice.user.addressLine2 }}</span><br>
                      {{ invoice.user.city }} {{ invoice.user.state }}, {{ invoice.user.postalCode }} <br>
                    </span><br>

                  {{ invoice.user.email }}<br>
                  {{ invoice.user.phoneNumber }}
                </v-card-text>

              </v-card>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="12"
            >

              <v-card outlined class="ma-0">
                <v-card-text>
                  <v-row>
                    <v-col
                        sm="6"
                        class="pt-2"
                    >
                      Invoice #:
                    </v-col>
                    <v-col
                        sm="6"
                        class="pt-2"
                    >
                      {{ invoice.id }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                        sm="6"
                        class="pt-0"
                    >
                      Invoice Date:
                    </v-col>
                    <v-col
                        sm="6"
                        class="pt-0"
                    >
                      {{ invoice.invoiceDate | formatLocalDate }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                        sm="6"
                        class="pt-0"
                    >
                      Due Date:
                    </v-col>
                    <v-col
                        sm="6"
                        class="pt-0"
                    >
                      {{ invoice.dueDate | formatLocalDate }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                        sm="6"
                        class="pt-0"
                    >
                      Status:
                    </v-col>
                    <v-col
                        sm="6"
                        class="pt-0"
                    >
                      {{ invoiceStatusMap[invoice.status] }}
                    </v-col>
                  </v-row>
                </v-card-text>

              </v-card>

            </v-col>
          </v-row>


          <v-row>
            <v-col
                lg="12"
            >

              <v-simple-table class="elevation-1">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-subtitle-2">Description</th>
                    <th class="text-subtitle-2 text-right">Price</th>
                    <th class="text-subtitle-2 text-right">Qty</th>
                    <th class="text-subtitle-2 text-right">Total</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in invoice.items"
                      :key="item.id"
                  >
                    <td class="item-description">
                      {{ item.description }}
                    </td>
                    <td class="item-price text-right">
                      {{ item.price | formatCurrency }}
                    </td>
                    <td class="item-qty text-right">
                      {{ item.quantity }}
                    </td>
                    <td class="item-amount text-right">
                      {{ item.amount | formatCurrency }}
                    </td>
                  </tr>

                  <tr
                      v-for="item in invoice.discounts"
                      :key="item.id"
                  >
                    <td class="item-description">
                      Discount: {{ item.description }}
                    </td>
                    <td class="item-price text-right">
                      -{{ item.value | formatCurrency }}
                    </td>
                    <td class="item-qty text-right">
                      1
                    </td>
                    <td class="item-amount text-right">
                      -{{ item.value | formatCurrency }}
                    </td>
                  </tr>


                  <tr
                      v-for="pmt in invoice.payments"
                      :key="pmt.id"
                  >
                    <td>
                      Payment on {{ pmt.date | formatLocalDate }} Method: {{ paymentMethodMap[pmt.method] }} Ref #: ...{{ pmt.reference.slice(-8) }}
                      <span v-if="pmt.status !== constants.PAYMENT_STATUS_VERIFIED">({{ paymentStatusMap[pmt.status] }})</span>
                    </td>
                    <td class="text-right">
                      -{{ pmt.amount | formatCurrency }}
                    </td>
                    <td class="text-right">
                      1
                    </td>
                    <td class="text-right">
                      <span v-if="pmt.status === constants.PAYMENT_STATUS_VERIFIED">
                        -{{ pmt.amount | formatCurrency }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="3" class="font-weight-bold">
                      Balance
                    </td>
                    <td class="text-right font-weight-bold">
                      {{ invoice.balance | formatCurrency }}
                    </td>
                  </tr>

                  </tbody>
                </template>
              </v-simple-table>


            </v-col>
          </v-row>


          <v-row>
            <v-col
                lg="3"
                v-if="invoice.comments"
            >
              Notes:
            </v-col>
            <v-col
                lg="9"
            >
              {{ invoice.comments }}
            </v-col>
          </v-row>

          <v-row v-if="showMakePayment">
            <v-col>
              <router-link :to="{name: 'stripe_payment'}">
                <v-btn
                    color="primary"
                    type="submit"
                    id="stripePayment"
                >
                  Make Payment
                </v-btn>
              </router-link>
              <router-link :to="{name: 'add_edit_payment', params: {invoiceId: invoice.id}}">
                <v-btn
                    color="primary"
                    type="button"
                    id="paymentProof"
                >
                  Add Proof of Payment
                </v-btn>
              </router-link>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              Please note that bank deposit and Zelle payments will not be applied to the invoice until they are reviewed by an administrator.
            </v-col>
          </v-row>




        </v-card-text>


      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import constants from '@/utils/constants'
import validation from "@/utils/validation";
import {mapGetters} from "vuex";
import SharedPageMessages from '@/views/components/shared/PageMessages.vue'

export default {
  name: 'CoreViewInvoiceView',

  components: {SharedPageMessages},

  created() {
    this.$gtag.event('view_invoice')

    this.userId = this.getUserId
    this.invoiceId = this.$route.params.id
    this.fetchInvoice()
  },
  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    }),
    constants() {
      return constants
    },
    showMakePayment() {
      if (this.invoice.status === constants.INVOICE_STATUS_PAID || this.invoice.balance === 0) {
        return false
      }

      for (const pmt of this.invoice.payments) {
        if (pmt.status === constants.PAYMENT_STATUS_ADMIN_REVIEW) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    fetchInvoice: function () {
      api
          .fetchInvoice(this.userId, this.invoiceId)
          .then(response => {
            this.invoice = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },

    handleError: function (err) {
      let errorMessage = api.parseResponseError(err)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      paymentValid: true,
      invoiceStatusValid: true,
      userId: null,
      invoice: null,
      invoiceStatusMap: constants.getInvoiceStatusMap(),
      paymentStatusMap: constants.getPaymentStatusMap(),
      paymentMethodMap: constants.getPaymentMethodMap(),
      payment: {},
      rules: {
        required: [
          v => validation.isRequired(v) || 'Is required'
        ],
        currency: [
          v => validation.isCurrency(v) || 'Must be in currency format'
        ],
      }
    }
  }
}
</script>

<style lang="scss">
td.item-amount, td.item-qty, td.item-price {
  width: 10%;
}
</style>

